import { generateURLWithParams } from 'utils';
import http from 'utils/http';

export const fetchPayoutsReport = (query) => {
  const url = generateURLWithParams('v1/organizations/{{organizationId}}/payouts/', query);
  return http.get(url);
};
